module.exports = __webpack_public_path__ + "static/goristro-fdccdad0661020add45675280e86f2f7.jpg";